module.exports = __webpack_public_path__ + "img/friend-4.41942277.png";